// const LANGUAGE_LISTS = [
//   { code: "ab", value: "ab", label: "Abkhazian" },
//   { code: "aa", value: "aa", label: "Afar" },
//   { code: "af", value: "af", label: "Afrikaans" },
//   { code: "ak", value: "ak", label: "Akan" },
//   { code: "sq", value: "sq", label: "Albanian" },
//   { code: "am", value: "am", label: "Amharic" },
//   { code: "ar", value: "ar", label: "Arabic" },
//   { code: "an", value: "an", label: "Aragonese" },
//   { code: "hy", value: "hy", label: "Armenian" },
//   { code: "as", value: "as", label: "Assamese" },
//   { code: "av", value: "av", label: "Avaric" },
//   { code: "ae", value: "ae", label: "Avestan" },
//   { code: "ay", value: "ay", label: "Aymara" },
//   { code: "az", value: "az", label: "Azerbaijani" },
//   { code: "bm", value: "bm", label: "Bambara" },
//   { code: "ba", value: "ba", label: "Bashkir" },
//   { code: "eu", value: "eu", label: "Basque" },
//   { code: "be", value: "be", label: "Belarusian" },
//   { code: "bn", value: "bn", label: "Bengali" },
//   { code: "bh", value: "bh", label: "Bihari" },
//   { code: "bi", value: "bi", label: "Bislama" },
//   { code: "bs", value: "bs", label: "Bosnian" },
//   { code: "br", value: "br", label: "Breton" },
//   { code: "bg", value: "bg", label: "Bulgarian" },
//   { code: "my", value: "my", label: "Burmese" },
//   { code: "ca", value: "ca", label: "Catalan, Valencian" },
//   { code: "km", value: "km", label: "Central Khmer" },
//   { code: "ch", value: "ch", label: "Chamorro" },
//   { code: "ce", value: "ce", label: "Chechen" },
//   { code: "ny", value: "ny", label: "Chichewa, Chewa, Nyanja" },
//   {
//     code: "cu",
//     value: "cu",
//     label: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
//   },
//   { code: "cv", value: "cv", label: "Chuvash" },
//   { code: "kw", value: "kw", label: "Cornish" },
//   { code: "co", value: "co", label: "Corsican" },
//   { code: "cr", value: "cr", label: "Cree" },
//   { code: "hr", value: "hr", label: "Croatian" },
//   { code: "cs", value: "cs", label: "Czech" },
//   { code: "da", value: "da", label: "Danish" },
//   { code: "dv", value: "dv", label: "Divehi, Dhivehi, Maldivian" },
//   { code: "nl", value: "nl", label: "Dutch, Flemish" },
//   { code: "dz", value: "dz", label: "Dzongkha" },
//   { code: "en", value: "en", label: "English" },
//   { code: "eo", value: "eo", label: "Esperanto" },
//   { code: "et", value: "et", label: "Estonian" },
//   { code: "ee", value: "ee", label: "Ewe" },
//   { code: "fo", value: "fo", label: "Faroese" },
//   { code: "fj", value: "fj", label: "Fijian" },
//   { code: "fi", value: "fi", label: "Finnish" },
//   { code: "fr", value: "fr", label: "French" },
//   { code: "ff", value: "ff", label: "Fulah" },
//   { code: "gd", value: "gd", label: "Gaelic, Scottish Gaelic" },
//   { code: "gl", value: "gl", label: "Galician" },
//   { code: "lg", value: "lg", label: "Ganda" },
//   { code: "ka", value: "ka", label: "Georgian" },
//   { code: "de", value: "de", label: "German" },
//   { code: "ki", value: "ki", label: "Gikuyu, Kikuyu" },
//   { code: "el", value: "el", label: "Greek (Modern)" },
//   { code: "kl", value: "kl", label: "Greenlandic, Kalaallisut" },
//   { code: "gn", value: "gn", label: "Guarani" },
//   { code: "gu", value: "gu", label: "Gujarati" },
//   { code: "ht", value: "ht", label: "Haitian, Haitian Creole" },
//   { code: "ha", value: "ha", label: "Hausa" },
//   { code: "he", value: "he", label: "Hebrew" },
//   { code: "hz", value: "hz", label: "Herero" },
//   { code: "hi", value: "hi", label: "Hindi" },
//   { code: "ho", value: "ho", label: "Hiri Motu" },
//   { code: "hu", value: "hu", label: "Hungarian" },
//   { code: "is", value: "is", label: "Icelandic" },
//   { code: "io", value: "io", label: "Ido" },
//   { code: "ig", value: "ig", label: "Igbo" },
//   { code: "id", value: "id", label: "Indonesian" },
//   {
//     code: "ia",
//     value: "ia",
//     label: "Interlingua (International Auxiliary Language Association)",
//   },
//   { code: "ie", value: "ie", label: "Interlingue" },
//   { code: "iu", value: "iu", label: "Inuktitut" },
//   { code: "ik", value: "ik", label: "Inupiaq" },
//   { code: "ga", value: "ga", label: "Irish" },
//   { code: "it", value: "it", label: "Italian" },
//   { code: "ja", value: "ja", label: "Japanese" },
//   { code: "jv", value: "jv", label: "Javanese" },
//   { code: "kn", value: "kn", label: "Kannada" },
//   { code: "kr", value: "kr", label: "Kanuri" },
//   { code: "ks", value: "ks", label: "Kashmiri" },
//   { code: "kk", value: "kk", label: "Kazakh" },
//   { code: "rw", value: "rw", label: "Kinyarwanda" },
//   { code: "kv", value: "kv", label: "Komi" },
//   { code: "kg", value: "kg", label: "Kongo" },
//   { code: "ko", value: "ko", label: "Korean" },
//   { code: "kj", value: "kj", label: "Kwanyama, Kuanyama" },
//   { code: "ku", value: "ku", label: "Kurdish" },
//   { code: "ky", value: "ky", label: "Kyrgyz" },
//   { code: "lo", value: "lo", label: "Lao" },
//   { code: "la", value: "la", label: "Latin" },
//   { code: "lv", value: "lv", label: "Latvian" },
//   { code: "lb", value: "lb", label: "Letzeburgesch, Luxembourgish" },
//   { code: "li", value: "li", label: "Limburgish, Limburgan, Limburger" },
//   { code: "ln", value: "ln", label: "Lingala" },
//   { code: "lt", value: "lt", label: "Lithuanian" },
//   { code: "lu", value: "lu", label: "Luba-Katanga" },
//   { code: "mk", value: "mk", label: "Macedonian" },
//   { code: "mg", value: "mg", label: "Malagasy" },
//   { code: "ms", value: "ms", label: "Malay" },
//   { code: "ml", value: "ml", label: "Malayalam" },
//   { code: "mt", value: "mt", label: "Maltese" },
//   { code: "gv", value: "gv", label: "Manx" },
//   { code: "mi", value: "mi", label: "Maori" },
//   { code: "mr", value: "mr", label: "Marathi" },
//   { code: "mh", value: "mh", label: "Marshallese" },
//   { code: "ro", value: "ro", label: "Moldovan, Moldavian, Romanian" },
//   { code: "mn", value: "mn", label: "Mongolian" },
//   { code: "na", value: "na", label: "Nauru" },
//   { code: "nv", value: "nv", label: "Navajo, Navaho" },
//   { code: "nd", value: "nd", label: "Northern Ndebele" },
//   { code: "ng", value: "ng", label: "Ndonga" },
//   { code: "ne", value: "ne", label: "Nepali" },
//   { code: "se", value: "se", label: "Northern Sami" },
//   { code: "no", value: "no", label: "Norwegian" },
//   { code: "nb", value: "nb", label: "Norwegian Bokmål" },
//   { code: "nn", value: "nn", label: "Norwegian Nynorsk" },
//   { code: "ii", value: "ii", label: "Nuosu, Sichuan Yi" },
//   { code: "oc", value: "oc", label: "Occitan (post 1500)" },
//   { code: "oj", value: "oj", label: "Ojibwa" },
//   { code: "or", value: "or", label: "Oriya" },
//   { code: "om", value: "om", label: "Oromo" },
//   { code: "os", value: "os", label: "Ossetian, Ossetic" },
//   { code: "pi", value: "pi", label: "Pali" },
//   { code: "pa", value: "pa", label: "Panjabi, Punjabi" },
//   { code: "ps", value: "ps", label: "Pashto, Pushto" },
//   { code: "fa", value: "fa", label: "Persian" },
//   { code: "pl", value: "pl", label: "Polish" },
//   { code: "pt", value: "pt", label: "Portuguese" },
//   { code: "qu", value: "qu", label: "Quechua" },
//   { code: "rm", value: "rm", label: "Romansh" },
//   { code: "rn", value: "rn", label: "Rundi" },
//   { code: "ru", value: "ru", label: "Russian" },
//   { code: "sm", value: "sm", label: "Samoan" },
//   { code: "sg", value: "sg", label: "Sango" },
//   { code: "sa", value: "sa", label: "Sanskrit" },
//   { code: "sc", value: "sc", label: "Sardinian" },
//   { code: "sr", value: "sr", label: "Serbian" },
//   { code: "sn", value: "sn", label: "Shona" },
//   { code: "sd", value: "sd", label: "Sindhi" },
//   { code: "si", value: "si", label: "Sinhala, Sinhalese" },
//   { code: "sk", value: "sk", label: "Slovak" },
//   { code: "sl", value: "sl", label: "Slovenian" },
//   { code: "so", value: "so", label: "Somali" },
//   { code: "st", value: "st", label: "Sotho, Southern" },
//   { code: "nr", value: "nr", label: "South Ndebele" },
//   { code: "es", value: "es", label: "Spanish, Castilian" },
//   { code: "su", value: "su", label: "Sundanese" },
//   { code: "sw", value: "sw", label: "Swahili" },
//   { code: "ss", value: "ss", label: "Swati" },
//   { code: "sv", value: "sv", label: "Swedish" },
//   { code: "tl", value: "tl", label: "Tagalog" },
//   { code: "ty", value: "ty", label: "Tahitian" },
//   { code: "tg", value: "tg", label: "Tajik" },
//   { code: "ta", value: "ta", label: "Tamil" },
//   { code: "tt", value: "tt", label: "Tatar" },
//   { code: "te", value: "te", label: "Telugu" },
//   { code: "th", value: "th", label: "Thai" },
//   { code: "bo", value: "bo", label: "Tibetan" },
//   { code: "ti", value: "ti", label: "Tigrinya" },
//   { code: "to", value: "to", label: "Tonga (Tonga Islands)" },
//   { code: "ts", value: "ts", label: "Tsonga" },
//   { code: "tn", value: "tn", label: "Tswana" },
//   { code: "tr", value: "tr", label: "Turkish" },
//   { code: "tk", value: "tk", label: "Turkmen" },
//   { code: "tw", value: "tw", label: "Twi" },
//   { code: "ug", value: "ug", label: "Uighur, Uyghur" },
//   { code: "uk", value: "uk", label: "Ukrainian" },
//   { code: "ur", value: "ur", label: "Urdu" },
//   { code: "uz", value: "uz", label: "Uzbek" },
//   { code: "ve", value: "ve", label: "Venda" },
//   { code: "vi", value: "vi", label: "Vietnamese" },
//   { code: "vo", value: "vo", label: "Volap_k" },
//   { code: "wa", value: "wa", label: "Walloon" },
//   { code: "cy", value: "cy", label: "Welsh" },
//   { code: "fy", value: "fy", label: "Western Frisian" },
//   { code: "wo", value: "wo", label: "Wolof" },
//   { code: "xh", value: "xh", label: "Xhosa" },
//   { code: "yi", value: "yi", label: "Yiddish" },
//   { code: "yo", value: "yo", label: "Yoruba" },
//   { code: "za", value: "za", label: "Zhuang, Chuang" },
//   { code: "zu", value: "zu", label: "Zulu" },
// ];

const LANGUAGE_LISTS = [
  { code: "en", value: "en", label: "English", title: "English (en)" },
  {
    code: "es",
    value: "es",
    label: "Spanish, Castilian",
    title: "Spanish, Castilian (es)",
  },
  { code: "fr", value: "fr", label: "French", title: "French (fr)" },
  {
    code: "nl",
    value: "nl",
    label: "Dutch, Flemish",
    title: "Dutch, Flemish (nl)",
  },
  { code: "de", value: "de", label: "German", title: "German (de)" },
  {
    code: "el",
    value: "el",
    label: "Greek",
    title: "Greek (el)",
  },
  { code: "it", value: "it", label: "Italian", title: "Italian (it)" },
  { code: "hi", value: "hi", label: "Hindi", title: "Hindi (hi)" },
  { code: "kn", value: "kn", label: "Kannada", title: "Kannada (kn)" },
  { code: "ml", value: "ml", label: "Malayalam", title: "Malayalam (ml)" },
  { code: "mr", value: "mr", label: "Marathi", title: "Marathi (mr)" },
  { code: "pt", value: "pt", label: "Portuguese", title: "Portuguese (pt)" },
  { code: "ta", value: "ta", label: "Tamil", title: "Tamil (ta)" },
  { code: "te", value: "te", label: "Telugu", title: "Telugu (te)" },
  { code: "tcy", value: "tcy", label: "Tulu", title: "Tulu (tcy)" },
];
export default LANGUAGE_LISTS;
